module Meevo.Plugins.AppointmentBook {
    class ResourceSharingController {
        appointmentServiceId: any;
        serviceCriteria: any;
        public resourceUnitAppointmentServices: any = [];
        public apptServicesWithResource = [];

        static $inject = [
            'appointmentBookGlobalsService', 
            'appointmentBookModalService', 
            'restServer', 
            'editorService', 
            'appointmentServiceId', 
            'resourceUnitAppointmentServices',
            'meevo.components.common.DataService',
            '$translate'
        ];

        constructor(
            private globals, 
            private modal, 
            private restServer, 
            private editorService: Meevo.Plugins.AppointmentBook.AppointmentEditorService, 
            appointmentServiceId, 
            resourceUnitAppointmentServices,
            private dataService,            
            private $translate
        ) {
            this.appointmentServiceId = appointmentServiceId;

            if (resourceUnitAppointmentServices) {
                this.resourceUnitAppointmentServices = resourceUnitAppointmentServices;
                return;
            }

            this.serviceCriteria = { isBookable: true, resourceId: this.editorService.currentDetail.resourceId };

            var shortestService = _.find(this.editorService.currentAppointment.services,
                (service:any) => {
                    return service.id != this.editorService.currentDetail.id &&
                        service.resourceId == this.editorService.currentDetail.resourceId &&
                        moment(service.startDateTime).isSame(this.editorService.currentDetail.startDateTime) &&
                        service.totalMinutes < this.editorService.currentDetail.totalMinutes;
                });
            if (shortestService == undefined) {
                shortestService = this.editorService.currentDetail;
            }
            this.restServer.getAppointmentServiceResources(shortestService, [], (response) => {

                const currentDetail = angular.copy(this.editorService.currentDetail);
                this.apptServicesWithResource = angular.copy(this.editorService.currentAppointment.services)
                    .filter(service => service.resourceId == currentDetail.resourceId);

                const currentResource = response.find(resource => resource.id === currentDetail.resourceId); 
                var availableUnitIds = currentResource.availableUnitIds;
                
                let overlappingApptServicesWithResource = this.apptServicesWithResource
                    .filter(service => this.isServicesOverlapped(service, shortestService));

                if (!overlappingApptServicesWithResource.find(service => service.id === currentDetail.id)) {
                    overlappingApptServicesWithResource.push(currentDetail);
                }

                this.resourceUnitAppointmentServices.push(...overlappingApptServicesWithResource);

                if (currentResource.canBeSplit) {
                    var existingResourceUnitIds = this.resourceUnitAppointmentServices.map(resourceUnit => resourceUnit.resourceUnitId);
                    availableUnitIds
                        .filter(unitId => existingResourceUnitIds.indexOf(unitId) < 0)
                        .forEach(unitId => this.resourceUnitAppointmentServices.push(this.getBlankResourceUnit(unitId)));
                } else {
                    const remainingCapacity = currentResource.capacity - this.resourceUnitAppointmentServices.length;
                    for (let index = 0; index < remainingCapacity; index++) {
                        this.resourceUnitAppointmentServices.push(this.getBlankResourceUnit(availableUnitIds[0]));
                    }
                }
                
                this.resourceUnitAppointmentServices = _.sortBy(this.resourceUnitAppointmentServices, 'service');
            });

        }

        getBlankResourceUnit(unitId) {
            return {
                stateEnum: Meevo.Model.StateEnum.Add,
                steps: [],
                id: NewGuid(),
                genderPreference: null,
                isNew: true,
                client: undefined,
                employee: undefined,
                appointType: undefined,
                startTimeSegmented: {
                    value: new Date(Date.now())
                },
                isWalkin: false,
                isRedo: false,
                isRequested: this.editorService.setIsRequested(),
                clientType: undefined,
                isInEdit: false,
                hasClientId: false,
                resource: this.editorService.currentDetail.resource,
                hasServiceAddOn: false,
                addOnCount: 0,
                serviceAddOns: [],
                resourceId: this.editorService.currentDetail.resourceId,
                resourceUnitId: unitId,
                isCurrentResourceUnit: false,
                appointmentServiceId: NewGuid()
            };
        }

        isServicesOverlapped(service1, service2) {
            return ((moment(service1.startDateTime).isBefore(moment(service2.startDateTime)) && (moment(service1.startDateTime).add("m", service1.totalMinutes).isAfter(moment(service2.startDateTime))))
                || (moment(service2.startDateTime).isBefore(moment(service1.startDateTime)) && (moment(service2.startDateTime).add("m", service2.totalMinutes).isAfter(moment(service1.startDateTime))))
                || (moment(service1.startDateTime).isSame(moment(service2.startDateTime)))
                || (moment(service1.startDateTime).add("m", service1.totalMinutes).isSame(moment(service2.startDateTime).add("m", service1.totalMinutes))));
        }

        clientChanged(resourceUnit, clientType) {
            if (clientType == "ClientType") {
                resourceUnit.client = {
                    id: undefined,
                    clientType: resourceUnit.clientType,
                    displayName: Model.ClientTypeEnum[resourceUnit.clientType].replace("Anonymous", "Anonymous ")
                }
                resourceUnit.clientId = undefined;
                this.editorService.setAddressOfAppointmentService(undefined, resourceUnit);
            } else {
                if (resourceUnit.client) {
                    resourceUnit.clientId = resourceUnit.client.id;
                    resourceUnit.clientType = Model.ClientTypeEnum.Client;
                    resourceUnit.clientPhoneNumber = resourceUnit.client.primeryPhoneNumber;
                    this.dataService.getItem("client", resourceUnit.clientId)
                        .then((response) => {
                            this.editorService.setAddressOfAppointmentService(response.address, resourceUnit);
                            resourceUnit.clientFirstName = response.firstName;
                            resourceUnit.clientLastName = response.lastName;
                            resourceUnit.clientDisplayName = response.displayName;
                        });
                }
            }

	        this.updateTemplate(resourceUnit);
        }

        serviceChanged(resourceUnit) {
            resourceUnit.customControlsAnswers = undefined;
            resourceUnit.hasServiceAddOn = false;
            resourceUnit.addOnCount = 0;
            resourceUnit.serviceAddOns = [];

            if (isObject(resourceUnit.service)) {
                this.editorService.setState(resourceUnit, Meevo.Model.StateEnum.Add);

                if (resourceUnit.service.isAddressRequired) {
                    // Need to set country so that state api call in address directive takes place
                    resourceUnit.country = "USA";
                }
            }

            this.updateTemplate(resourceUnit);
        }

        updateTemplate(resourceUnit) {
            if (!resourceUnit.service) {
                return;
            }
           
			const serviceId = resourceUnit.service.id;
	        const employeeId = resourceUnit.employeeId;
	        const clientId = resourceUnit.clientId;

            let serviceAddOnIds = _(resourceUnit.serviceAddOns).map(serviceAddOn => serviceAddOn.addOnServiceId);

            this.restServer.getAppointmentServiceTemplateWithAddOns(
                employeeId,
                serviceId,
                clientId,
                serviceAddOnIds,
                this.editorService.getDateTime(resourceUnit),
                (response) => {
                    resourceUnit.employeePerformsService = response.employeePerformsService;
                    resourceUnit.doNotAllowStepTimingOverride = response.doNotAllowStepTimingOverride;
                    resourceUnit.serviceNoteAlertsCount = 0;
                    resourceUnit.serviceNoteAlerts = [];
                    resourceUnit.allowGenderPreference = response.allowGenderPreference;
                    resourceUnit.finalState = response.finalState;
                    resourceUnit.transitionState = response.transitionState;
                    resourceUnit.price = response.price;
                    resourceUnit.totalMinutes = response.totalMinutes;
                    resourceUnit.startDateTime = this.editorService.getDateTime(this.editorService.currentDetail);
                    resourceUnit.serviceId = resourceUnit.service.id;
                    resourceUnit.isResourceRequired = response.isResourceRequired;
                    resourceUnit.hasBookingCustomControls = response.hasBookingCustomControls;
                    resourceUnit.hasServiceAddOn = response.hasServiceAddOn;
                    resourceUnit.addOnCount = response.addOnCount;
                    resourceUnit.serviceAvailableForMale = resourceUnit.service.availableForMale;
                    resourceUnit.serviceAvailableForFemale = resourceUnit.service.availableForFemale;
                    resourceUnit.startTime = this.editorService.currentDetail.startTime;
                    resourceUnit.steps = response.steps;

                    if (this.globals.businessInfo.enableIntegratedRegister)
                    {
                        const services = [{
                            serviceId, 
                            employeeId, 
                            clientId 
                        }];

                        this.restServer.getRegisterPriceList(services).then((response) => {
                            if (response.data.services.length === 1) {
                                const firstService = response.data.services[0];
                                resourceUnit.adjustedPrice = firstService.finalPriceCharge;
                            }
                        });
                    }

                    resourceUnit.steps = [];
                    response.steps.forEach((step) => {
                        step.stateEnum = Meevo.Model.StateEnum.Add;
                        step.appointmentServiceId = resourceUnit.id;
                        if (!resourceUnit.employee) {
                            step.employeeId = null;
                        }
                        resourceUnit.steps.push(step);
                    });

                    this.editorService.calculateStepDuration(resourceUnit);

                    if (resourceUnit.isResourceRequired) {
                        this.restServer.getAppointmentServiceResources(resourceUnit, this.apptServicesWithResource, (serviceResponse) => {
                            if (_.where(serviceResponse, { isAvailable: true, id: resourceUnit.resourceId }).length === 0) {
                                this.modal.showMessage(this.$translate.instant("MESSAGE_NO_RESOURCES_AVAILABLE", { serviceDisplayName: serviceResponse.displayName }));
                                resourceUnit.serviceId = undefined;
                                resourceUnit.service = undefined;
                                resourceUnit.steps = [];
                            }
                        });
                    }
                });
        }

        employeeChanged(resourceUnit) {
            if (resourceUnit.employee) {
                resourceUnit.employeeId = resourceUnit.employee.id;

                resourceUnit.employeeCode = resourceUnit.employee.code;
                resourceUnit.employeeFirstName = resourceUnit.employee.firstName;
                resourceUnit.employeeLastName = resourceUnit.employee.lastName;
                resourceUnit.employeeDisplayName = resourceUnit.employee.displayName;
                resourceUnit.employeeGender = resourceUnit.employee.gender;
            } else {
                resourceUnit.employeeId = undefined;

                resourceUnit.employeeCode = undefined;
                resourceUnit.employeeFirstName = undefined;
                resourceUnit.employeeLastName = undefined;
                resourceUnit.employeeDisplayName = undefined;
                resourceUnit.employeeGender = undefined;
            }
 
            this.updateTemplate(resourceUnit);
        }

        employeeRequired(resourceUnit) {
            return this.editorService.employeeRequired(resourceUnit);
        }

        saveResourceUnits() {
            this.editorService.saveResourceUnitAppointmentServices(this.resourceUnitAppointmentServices);
            if (_(this.editorService.currentAppointment.services).findWhere({ id: this.editorService.currentDetail.id })) {
                this.editorService.selectAppointDetail(this.editorService.currentDetail.id, false);
            }
            this.modal.hideModal();
        }

        preAddEditClient() {
            this.editorService.resourceSharingPreAddEditClient(this.appointmentServiceId, this.resourceUnitAppointmentServices);
        }
    }
    angular.module("ApptBookApp")
        .controller("meevo.plugins.appointmentBook.ResourceSharingController", ResourceSharingController);
}